module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"less":"Show less","more":"Show more"}}')
  delete Component.options._Ctor
}
